/** Mirrors the closed saved Approval config. The server validates current members and fields. */
const invalidIdentifier = (id: string) =>
  /\s/.test(id) ||
  [...id].some((char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127);

export function approvalConfigError(config: unknown): string | null {
  if (!config || typeof config !== 'object' || Array.isArray(config))
    return 'Choose who approves these records.';
  const c = config as Record<string, unknown>;
  if (
    Object.keys(c).some(
      (key) =>
        !['approvers', 'notify', 'timeoutDays', 'onTimeout', 'show'].includes(
          key
        )
    )
  )
    return 'Remove unsupported approval settings.';
  const a = c.approvers;
  if (!a || typeof a !== 'object' || Array.isArray(a))
    return 'Choose who approves these records.';
  const approvers = a as Record<string, unknown>;
  if (
    Object.keys(approvers).some((key) => !['mode', 'userIds'].includes(key)) ||
    !['play_owner', 'users', 'record_owner'].includes(String(approvers.mode))
  )
    return 'Choose who approves these records.';
  const ids = approvers.userIds;
  if (
    ids !== undefined &&
    (!Array.isArray(ids) ||
      ids.some(
        (id) =>
          typeof id !== 'string' ||
          !id ||
          id.length > 128 ||
          invalidIdentifier(id)
      ) ||
      new Set(ids).size !== ids.length)
  )
    return 'Choose distinct current people.';
  if (
    approvers.mode === 'users'
      ? !Array.isArray(ids) || ids.length < 1 || ids.length > 10
      : Array.isArray(ids) && ids.length > 0
  )
    return 'Choose 1 to 10 people for approval.';
  if (
    c.notify !== undefined &&
    (!c.notify ||
      typeof c.notify !== 'object' ||
      Array.isArray(c.notify) ||
      Object.entries(c.notify).some(
        ([key, value]) =>
          !['slack', 'teams', 'email'].includes(key) ||
          typeof value !== 'boolean'
      ))
  )
    return 'Choose Slack, Teams, Email or dashboard only.';
  if (
    c.timeoutDays != null &&
    (!Number.isInteger(c.timeoutDays) ||
      Number(c.timeoutDays) < 1 ||
      Number(c.timeoutDays) > 30)
  )
    return 'Choose no deadline or 1 to 30 days.';
  if (
    c.onTimeout !== undefined &&
    !['reject', 'approve'].includes(String(c.onTimeout))
  )
    return 'Choose what happens at the deadline.';
  if (
    c.show !== undefined &&
    (!Array.isArray(c.show) ||
      c.show.length > 8 ||
      c.show.some(
        (id) =>
          typeof id !== 'string' ||
          !id ||
          id.length > 512 ||
          invalidIdentifier(id)
      ) ||
      new Set(c.show).size !== c.show.length)
  )
    return 'Choose up to 8 distinct fields to show.';
  return null;
}
